import { outreachAnalyticsSchema } from "@redotech/redo-marketing-common/campaigns/campaign-definition";
import { OutreachGroupKeySchema } from "@redotech/redo-model/aggregated-metrics/outreach";
import * as z from "zod/v4";

export const getOutreachAnalytics = {
  name: "getOutreachAnalytics" as const,
  input: z.object({
    groupBy: OutreachGroupKeySchema,
    metricsStart: z
      .string()
      .optional()
      .describe("Start date for the analytics period (YYYY-MM-DD)"),
    metricsEnd: z
      .string()
      .optional()
      .describe("End date for the analytics period (YYYY-MM-DD)"),
  }),
  output: outreachAnalyticsSchema,
};
